import { simpleCampaignsQueryOptions } from "@/api/campaign.api";
import { CampaignDetailsForm } from "@/components/campaign/setup/CampaignDetailsForm";
import { getFinalCampaignName } from "@/utils/campaign-helpers";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useCallback, useMemo } from "react";
export const Route = createFileRoute("/_dashboard/campaigns/setup/details/")({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Detaljer",
    },
  },
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(simpleCampaignsQueryOptions);
  },
});

function RouteComponent() {
  const { useStepper, user, ...context } = Route.useRouteContext();

  const stepper = useStepper();

  const { data: simpleCampaigns } = useSuspenseQuery(
    simpleCampaignsQueryOptions,
  );

  const placeholder = useMemo(() => {
    return getFinalCampaignName(stepper.context.name ?? "", simpleCampaigns);
  }, [stepper.context.name, simpleCampaigns]);

  const campaignName = useMemo(
    () => stepper.context.name ?? "",
    [stepper.context.name],
  );
  const responsibleId = useMemo(
    () => stepper.context.responsibleId ?? user.id,
    [stepper.context.responsibleId, user.id],
  );

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  context.stepper.useStepperSubmit(submitHandler);

  return (
    <div className="flex grow flex-col items-center justify-center">
      <CampaignDetailsForm
        placeholder={placeholder}
        values={useMemo(
          () => ({
            campaignName,
            responsibleId,
          }),
          [campaignName, responsibleId],
        )}
        onSubmit={useCallback(
          (data) => {
            stepper.setContext((prev) => {
              return {
                ...prev,
                name: data.campaignName,
                responsibleId: data.responsibleId,
              };
            });
            stepper.goNext();
          },
          [stepper],
        )}
        setSubmitHandler={setSubmitHandler}
      />
    </div>
  );
}
